export const supportContent = `For questions send us a DM on [Bluesky](https://batesky.app/profile/batesky.app).

If you need help, send us a DM or email us with a description of your issue and information about how we can help you at [support@batesky.app](mailto:support@batesky.app).
`
